import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

export const AccountButton = {
  name: 'AccountButton',
  computed: {
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    },
    user () {
      return this.$store.state.user.current
    },
    isAuthElem () {
      return this.$store.state.ui.isAuthElem
    }
  },
  methods: {
    goToAccount () {
      if (this.currentUser) {
        this.$router.push(this.localizedRoute('/my-account'))
      } else {
        this.isAuthElem ? EventBus.$emit('modal-hide', 'modal-signup') : EventBus.$emit('modal-show', 'modal-signup')
        this.$store.commit('ui/setAuthElem', 'login')
      }
    },
    logout () {
      EventBus.$emit('user-before-logout')
      this.$router.push(this.localizedRoute('/'))
    }
  }
}
